// Cómo se dice, en TODO el backoffice, un dato que la pantalla no puede traer. Un cero afirma que
// no hay ninguno y un guion mudo deja al operador adivinando: aquí se lee, y el porqué está al
// alcance del cursor.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** El hueco de UN dato, en línea con lo que lo rodea. */
export function NoSource({ reason, className }: { reason: string; className?: string }) {
    return (
        <span className={cn('cursor-help italic text-muted-foreground', className)} title={reason}>
            sin fuente
        </span>
    );
}

/** El hueco de un BLOQUE entero: ocupa el lugar de la lista y dice en texto por qué está vacía. */
export function NoSourceBlock({
    children,
    className,
}: {
    children: ReactNode;
    className?: string;
}) {
    return (
        <p
            className={cn(
                'p-3 text-center text-[11px] italic leading-relaxed text-muted-foreground',
                className,
            )}
        >
            {children}
        </p>
    );
}
